import styled from 'styled-components';
import { colors, fontFamily, zIndex } from '../../ui/variables';

export const WindowWidthLevelSelectStyle = styled.div`
  position: relative;
  display: inline-block; /* ou flex, dependendo de como quer alinhar */
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

  .icon-container {
      background-color: ${colors.veryDarkGrayishBlue};
      padding: 6px;
      border-radius: 8px;

    .icon-button {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;

      svg {
        width: 24px;
        height: 24px;
        fill: ${colors.white};
      }

    }
  }

  .types-list-container {
    ${zIndex.space};
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background-color: ${colors.veryDarkGrayishBlue};
    border-radius: 8px;
    padding: 8px 0;
    min-width: 120px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    max-height: 240px;
    min-width: 200px;
    overflow-y: auto;
    z-index: 999;

    .type-option {
      display: block;
      width: 100%;
      text-align: left;
      background: transparent;
      border: none;
      padding: 8px 16px;
      color: ${colors.verySoftBlue};
      font-size: 14px;
      line-height: 20px;
      ${fontFamily.sourceSansPro.regular};
      cursor: pointer;

      &.selected {
        ${fontFamily.sourceSansPro.bold};
      }

    }
  }
`;
